import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from 'antd'

const { Text } = Typography

// WhatsApp renders *text* as bold; show it the same way so the owner sees what the customer sees.
const formatLine = (line, lineIndex) =>
  line.split(/(\*[^*\n]+\*)/g).map((part, i) =>
    /^\*[^*\n]+\*$/.test(part) ? (
      <strong key={`${lineIndex}-${i}`}>{part.slice(1, -1)}</strong>
    ) : (
      <React.Fragment key={`${lineIndex}-${i}`}>{part}</React.Fragment>
    )
  )

const bubble = {
  background: '#dcf8c6',
  color: '#111',
  borderRadius: 8,
  padding: '8px 10px',
  maxWidth: 360,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  boxShadow: '0 1px 1px rgba(0,0,0,0.15)',
  fontSize: 14,
  lineHeight: 1.45
}

const button = {
  background: '#fff',
  color: '#027eb5',
  borderRadius: 8,
  padding: '6px 10px',
  marginTop: 4,
  maxWidth: 360,
  textAlign: 'center',
  boxShadow: '0 1px 1px rgba(0,0,0,0.15)'
}

const WhatsAppPreview = ({ text, buttons, droppedLines, loading }) => (
  <div style={{ background: '#ece5dd', borderRadius: 8, padding: 12, minHeight: 80 }}>
    {text ? (
      <div style={{ ...bubble, opacity: loading ? 0.6 : 1 }}>
        {text.split('\n').map((line, i) => (
          <div key={i}>{line ? formatLine(line, i) : ' '}</div>
        ))}
      </div>
    ) : (
      <Text type="secondary">Nothing to preview yet.</Text>
    )}
    {(buttons || []).map(label => (
      <div key={label} style={button}>
        {label}
      </div>
    ))}
    {droppedLines && droppedLines.length > 0 && (
      <div style={{ marginTop: 8 }}>
        <Text type="secondary" style={{ fontSize: 12 }}>
          Left out when there&apos;s no value: {droppedLines.join(' · ')}
        </Text>
      </div>
    )}
  </div>
)

WhatsAppPreview.propTypes = {
  text: PropTypes.string,
  buttons: PropTypes.arrayOf(PropTypes.string),
  droppedLines: PropTypes.arrayOf(PropTypes.string),
  loading: PropTypes.bool
}

export default WhatsAppPreview
